/**
 * Score Module Type Definitions
 */

/**
 * Team with score information
 */
export interface TeamScore {
  id: string;
  name: string;
  color: string | null;
  avatar_url: string | null;
  description: string | null;
  total_score: number;
  weekend_id: string;
  member_count: number;
  rank: number;
}

/**
 * Individual user score contribution
 */
export interface IndividualScore {
  user_id: string;
  full_name: string | null;
  nickname: string | null;
  avatar_url: string | null;
  team_id: string | null;
  team_name: string | null;
  team_color: string | null;
  total_points: number;
  rank: number;
}

/**
 * Score history entry from the database
 */
export interface ScoreHistoryEntry {
  id: string;
  team_id: string;
  team_name?: string;
  team_color?: string;
  points: number;
  previous_total: number;
  new_total: number;
  reason: string;
  game_type: string | null;
  game_id: string | null;
  awarded_by: string | null;
  awarded_by_name?: string;
  awarded_to: string | null;
  awarded_to_name?: string;
  awarded_to_avatar?: string;
  created_at: string;
}

/**
 * Score summary by game type
 */
export interface ScoreSummaryByType {
  game_type: string;
  total_points: number;
  entries_count: number;
}

/**
 * Team detail with full score breakdown
 */
export interface TeamScoreDetail extends TeamScore {
  history: ScoreHistoryEntry[];
  summary_by_type: ScoreSummaryByType[];
  members: {
    user_id: string;
    full_name: string | null;
    nickname: string | null;
    avatar_url: string | null;
    is_captain: boolean;
    points_contributed: number;
  }[];
}

/**
 * User score detail with contributions
 */
export interface UserScoreDetail {
  user_id: string;
  full_name: string | null;
  nickname: string | null;
  avatar_url: string | null;
  team_id: string | null;
  team_name: string | null;
  team_color: string | null;
  total_points: number;
  rank: number;
  contributions: ScoreHistoryEntry[];
  summary_by_type: ScoreSummaryByType[];
}

